import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Avatar from 'shared-web/src/components/Avatar'
import TetherComponent from 'react-tether'

import TitleCard from 'components/customer/TitleCard'

export default class HoverAvatar extends Component {
  static propTypes = {
    attachment: PropTypes.string,
    targetAttachment: PropTypes.string,
    targetOffset: PropTypes.string,
  }

  static defaultProps = {
    attachment: 'top left',
    targetAttachment: 'top right',
    targetOffset: '0 10px',
  }

  state = {
    displayCard: false,
  }

  showCard = () => {
    this.setState({ displayCard: true })
  }

  hideCard = () => {
    this.setState({ displayCard: false })
  }

  handleOnMouseOver = () => {
    this.showCardTimeout = setTimeout(this.showCard, 100)
    clearTimeout(this.hideMenuTimeout)
  }

  handleOnMouseLeave = () => {
    this.hideMenuTimeout = setTimeout(this.hideCard, 100)
    clearTimeout(this.showCardTimeout)
  }

  renderAvatar(avatarProps) {
    return (
      <div onMouseOver={this.handleOnMouseOver} onMouseLeave={this.handleOnMouseLeave}>
        <Avatar {...avatarProps} />
      </div>
    )
  }

  render() {
    const { attachment, targetAttachment, targetOffset, ...avatarProps } = this.props
    if (this.state.displayCard) {
      return (
        <TetherComponent
          attachment={attachment}
          targetAttachment={targetAttachment}
          targetOffset={targetOffset}
          constraints={[{ to: 'scrollParent', attachment: 'together' }]}
        >
          {this.renderAvatar(avatarProps)}
          <div onMouseOver={this.handleOnMouseOver} onMouseLeave={this.handleOnMouseLeave}>
            <TitleCard endUser={this.props.user} showProfileLink editable={false} width="300px" />
          </div>
        </TetherComponent>
      )
    } else {
      return this.renderAvatar(avatarProps)
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/shared/HoverAvatar/index.js